import React, { Component } from 'react';
import {Form, Control, Errors, Fieldset} from "react-redux-form";
import ScrollToTopOnMount from './../scroll_top';
import _ from "lodash";
import {email} from "../field_validations";
import {toInt} from "../parsers";

export default class MessagesEditForm extends Component {
	render(){
		const { messages, modality, project } = this.props;
		let nmc = _.find(messages.permissions, (o) => {return o==='Create'}) ? true:false;
		return(
			<div className="columns is-centered">
				<div className="column is-10">
					<ScrollToTopOnMount {...this.props}/>
					<Form model="messages.edit" onSubmit={(values) => this._handleSubmit(values)}>
						{modality === 'modalidad-ii' ?
							<div className="field is-grouped">
								<div className="control">
									<label htmlFor="state" className="label">Estado</label>
									<div className="select">
										<Control.select model=".entity.id" defaultValue={messages.edit.entity.id} parser={ toInt } changeAction={(model,value) => this._handleCheckState(model,value)}>
											<option value="">-- Estados --</option>
											{_.map(messages.edit.states,(state,k) => {
												return <option value={state.id} key={k}>{state.name}</option>
											})}
										</Control.select>
									</div>
								</div>

								<div className="control">
									<div className="notification is-info has-text-white">
										<div className="field">
											<div className="control">
												<label htmlFor="reviewedState" className="checkbox" disabled={this._permisionEdit()}>
													<Control.checkbox model=".entity.reviewed" id="reviewedState" className="checkbox" changeAction={(model,value) => this._handleCheckValidate(model,value)} disabled={this._permisionEdit()}/>
													<span style={{whiteSpace:'normal'}}>He concluido con la validación de este estado</span>
												</label>
											</div>
										</div>
										{messages.edit.entity.isFetching ?
											<div className="field"><span className="icon"><i className="fa fa-spinner fa-pulse fa-fw"/></span></div>
											:''}
									</div>
								</div>
							</div>
							:''}
						<Fieldset model=".agencies">
							<h1 className="title is-6">VALIDACION DE PARTICIPANTES</h1>
							<table className="is-fullwidth table project-goal-table no-margin">
								<tbody>
								{_.map(this._listAgencies(), (item, k) => {
									return [
										<tr key={`instance-${k}`}>
											<td colSpan={3} className="goal-cell">
												<span className="help is-white">Instancia</span>
												<strong>{item.agency ? item.agency.name:'---'}</strong>
											</td>
											<td className="goal-cell">
												{modality !== 'modalidad-ii' ?
													<span className="help is-white">Estado</span>:
													<span className="help is-white">Municipio</span>}

												<strong>{item.agency ? item.agency.agenciable.name:'---'}</strong>
											</td>
										</tr>,
										<tr key={`general-${k}`}>
											<td>
												<span className="help is-dark">Titular</span>
												<strong>{item.agency  ? `${item.agency.owner.name} ${item.agency.owner.last_name} ${item.agency.owner.slast_name}`:'---'}</strong>
											</td>
											<td colSpan={2}>
												<span className="help is-dark">Email de la instancia</span>
												<strong>{item.agency ? item.agency.email:'---'}</strong>
												<br />
												<span className="help is-dark">Email de titular</span>
												<strong>{item.agency ? item.agency.owner.email:'---'}</strong>
											</td>
											{/*<td>
															<span className="help is-dark">Comentario</span>
															<strong>{!_.isEmpty(item.comments) ? item.comments : 'Sin comentarios'}</strong>
														</td>*/}
											<td>
												{!_.isEmpty(item.project_version_phase_group) && !_.isEmpty(item.project_version_phase_group.revisions) ?
													_.map(item.project_version_phase_group.revisions, (rev, o) => {
														return [
															<span className="help is-dark" key={o}>{`Revisión ${rev.project_version_phase.version_phase.phase.name}`}</span>,
															<strong key={`status-${o}`}><span className="has-text-success">Revisado</span></strong>
														]
													})
													:<strong><span className="has-text-danger">No Revisado</span></strong>}
											</td>
										</tr>,
										<tr key={`notification-${k}`}>
											<td colSpan={4}>
												<span className="help is-dark">Notificación</span>
												<strong>{item.project_version_phase_group && item.project_version_phase_group.notification && item.project_version_phase_group.notification.notification_type
													? item.project_version_phase_group.notification.notification_type.name:'--Sin notificación--'}</strong>
											</td>
										</tr>
									];
								})}
								</tbody>
							</table>
						</Fieldset>

						<div className="field">
							<div className="control">
								<button type="button" className="button is-large is-info" onClick={() => this.props.notificationMessagesExport(modality)}>
									<span className="icon is-medium"><i className="fa fa-download" /></span>
									<span>Exportar</span>
								</button>
							</div>
						</div>

						<fieldset className="fieldset">
							<legend>Prueba de envio</legend>
							<div className="field is-grouped">
								<div className="control">
									<div className="notification is-inm-purple">
										<div className="field">
											<div className="control">
												<label className="checkbox" disabled={Boolean(messages.edit.finished)}>
													<Control.checkbox model=".is_test" isToggle={true} defaultValue={true} disabled={Boolean(messages.edit.finished)}/>
													Prueba de envio
												</label>
											</div>
										</div>
									</div>
								</div>

								<div className="control">
									<label htmlFor="test_email" className="label">E-mail</label>
									<Control.text className="input" type="email" model=".test_email" id="test_email" placeholder="usuario@dominio.com" errors={{email}} />
									<Errors model=".test_email" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{email: 'El email es inválido'}} />
									{messages.edit.is_test ?
										messages.edit.test_email ?
											''
											:<small className="help has-text-danger">El email es obligatorio</small>
										:''}
								</div>
							</div>
						</fieldset>

						<fieldset className="fieldset">
							<legend>Mensajes de notificación</legend>

							{!_.isEmpty(messages.notifications_types) ?
								_.map(messages.notifications_types,(msg,k) => {
									return (
										<div className="field" key={k}>
											<div className="control">
												<label htmlFor={`.notifications_types${k}`} className="label">Mensaje para notificacion <span className="has-text-primary">{msg.name}</span></label>
												<fieldset className="fieldset">
													<small><span dangerouslySetInnerHTML={{__html:msg.body ? msg.body : ''}}></span></small>
												</fieldset>
											</div>
										</div>
									);
								})
							:''}
						</fieldset>

						<div className="message is-success">
							<div className="message-body">
								<div className="field">
									<div className="control">
										<label htmlFor="finished" className="checkbox" disabled={messages.edit.is_test}>
											<Control.checkbox model=".finished" id="finished" className="checkbox" disabled={messages.edit.is_test}/>
											<span style={{whiteSpace:'normal'}}>He concluido con la validación de las notificaciones y certifico que la información proporcionada es correcta y completa; conozco las disposiciones establecidas en las Reglas de Operación de ProEquidad {project.version.year}.</span>
										</label>
									</div>
								</div>
							</div>
						</div>

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-danger" onClick={() => this.props.history.goBack()}>
									Regresar
								</button>
							</div>

							{nmc ?
								<div className="control">
									<Control.button model="messages.edit" className="button is-success" disabled={this._permissionSave()}>Enviar notifiaciones</Control.button>
								</div> :''}
						</div>
					</Form>
				</div>
			</div>
		);
	}

	_handleSubmit(values){
		let { modality } = this.props;
		this.props.notificationMessagesSave(values, modality);
	}

	_listAgencies(){
		let {messages, modality}=this.props;

		let listAgencies = []
		if(modality !== 'modalidad-ii' && !_.isEmpty(messages.list)){
			listAgencies = messages.list;
		}else if(!_.isEmpty(messages.list)){
			listAgencies = _.filter(messages.list,{agency:{agenciable:{state_id:messages.edit.entity.id}}});
		}

		return listAgencies;
	}

	_handleCheckValidate(model,value){
		let {messages, modality}=this.props;
		let state= messages.edit.entity.id;
		let index = _.findIndex(messages.edit.states,{id: state});
		this.props.change(model, value);
		this.props.change(`messages.edit.states[${index}].reviewed`,value ? 1:0);
		this.props.notificationStateReviewedSave(value ? 1:0, modality, _.find(messages.edit.states,{id: state}).short)
	}

	_handleCheckState(model,value){
		let {messages}=this.props;
		let state = _.find(messages.edit.states,{id: value});
		this.props.change(model,value);
		this.props.change('messages.edit.entity.reviewed',state && state.reviewed ? true:false);
	}

	_validateState(state){
		let {states}=this.props.messages.edit;
		return _.get({body:{..._.find(states,{id: state})}},'body.reviewed',false);
	}

	_permisionEdit(reviewed){
		let {messages }=this.props;
		if(reviewed){
			return reviewed;
		}else {
			return Boolean(messages.edit.finished);
		}
	}

	_permissionSave(){
		let {messages, modality}=this.props;
		let total = _.size(messages.edit.states);
		let validated = _.size(_.filter(messages.edit.states,'reviewed'));
		if(modality==='modalidad-ii'){
			if(messages.edit.is_test && !_.isEmpty(messages.edit.test_email)){
				return false;
			}else if(messages.edit.finished && total===validated){
				return false;
			}else {
				return true;
			}
		}else {
			if(Boolean(messages.edit.finished)){
				return false;
			}else if(messages.edit.is_test && !_.isEmpty(messages.edit.test_email)){
				return false;
			}else {
				return true;
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/elements/notifications/messages.jsx